import { AppliedFilterBarOpt, FilterBarInputOpt, FilterGroup, IFilterBar } from "../../../models/utilities/filter-bar";
import { ListColumn, SelectedSort } from "../../../models/utilities/list-header";
import { PageData } from "../../../models/utilities/paged-request";
import { ApiEndpoints, GlobalConstants } from "../../../utils/app-constants";

export class DealerSearchFilters implements IFilterBar {

    public paginationInfo   : PageData = new PageData(GlobalConstants.DEFAULT_PAGE_SIZE);
    public baseUrl          : string = ApiEndpoints.DEALER_SEARCH;
    public filters          : FilterGroup[] = [];
    public appliedFilters   : AppliedFilterBarOpt[] = [];
    public requiredFilters  : AppliedFilterBarOpt[] = [];
    public columns          : ListColumn[];
    public selectedSort     : SelectedSort;
    
    constructor() {

        // Set our table columns
        this.columns = [
            new ListColumn('ID', ''),
            new ListColumn('Name', ''),
            new ListColumn('City', ''),
            new ListColumn('State', '')
        ];

        // Create our Filter Groups
        const byName = this.buildName();
        
        this.filters.push(
            byName
        );

    }

    // #region Group Builders

    private buildName() {
        const byName = new FilterGroup('Name', 'text', 'query');
        const opt1 = new FilterBarInputOpt('Name', '');
        
        byName.opts = [opt1];

        return byName;
    }
    
    // #endregion

}
